import { enumSocialMediaPostType } from "../../../enums";
import { referenceIsForAFacebookPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/facebookUtilities";
import { referenceIsForAGabPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/gabUtilities";
import { referenceIsForAnInstagramPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/instagramUtilities";
import { referenceIsForALInkedInPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/linkedInUtilities";
import { referenceIsForAPinterestPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/pinterestUtilities";
import { referenceIsForATikTokPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/tiktokUtilities";
import { referenceIsForATruthSocialPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/truthSocialUtilities";
import { referenceIsForATwitterOrXPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/twitterOrXUtilities";
import { referenceIsForAYouTubeAsset } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/youtubeUtilities";

/**
 * @function determineSocialMediaPostTypeFromRawReference Determines and returns the Social Media Post Type from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function determineSocialMediaPostTypeFromRawReference(socialMediaPostRawReference: string): enumSocialMediaPostType {

  // the return value
  let socialMediaPostType: enumSocialMediaPostType = enumSocialMediaPostType.Undefined;

  // check for each social media post type until a type is determined, or until the list of types has been exhausted

  // Facebook Post
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForAFacebookPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.FacebookPost;
    }
  }

  // Gab
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForAGabPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.Gab;
    }
  }

  // Instagram
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForAnInstagramPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.Instagram;
    }
  }

  // LinkedIn
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForALInkedInPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.LinkedIn;
    }
  }

  // Pinterest
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForAPinterestPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.Pinterest;
    }
  }

  // TikTok
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForATikTokPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.TikTok;
    }
  }

  // Truth Social
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForATruthSocialPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.TruthSocial;
    }
  }

  // X or Twitter
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForATwitterOrXPost(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.XOrTwitter;
    }
  }

  // YouTube
  if (socialMediaPostType === enumSocialMediaPostType.Undefined) {
    if (referenceIsForAYouTubeAsset(socialMediaPostRawReference)) {
      socialMediaPostType = enumSocialMediaPostType.YouTube;
    }
  }

  return socialMediaPostType;
}
